import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-novos',
  templateUrl: './novos.component.html',
  styleUrl: './novos.component.css'
})
export class ContratosNovosComponent {

}
